//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'stage',
  title: 'Sierra Item',
  name: 'sierra-asset',
  knittingMachineCategoryId: '673c07b2a128eab872eb6c2d',
  doubleKnitAssetTypeId: '67acdba2ee06eac3505f985f',
  finishingAssetCategory: '67fdbaa6f37a22aafe95f6e0',
  proxyUrls: {
    assetApi: 'https://asset.api.stage.sierra-erp.com',
    itemApi: 'https://item.api.stage.sierra-erp.com',
    userMasterApi: 'https://user.api.stage.sierra-erp.com',
    orderApi: 'https://order.api.stage.sierra-erp.com',
    financeApi: 'https://finance.api.stage.sierra-erp.com',
    inventoryApi: 'https://inventory.api.stage.sierra-erp.com',
  },
  featureFlags: {
    // GL Accounts section in the Item Master modal. Hidden in prod for now.
    itemMasterGlAccounts: true,
  },
};
